// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { Component, TemplateRef } from '@angular/core';
import { ToastService, ToastInfo } from '@lfx/core/services';

@Component({
  selector: 'lfx-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  host: {
    class: 'toast-container',
    'aria-live': 'polite',
    'aria-atomic': 'true'
  },
  standalone: false,
})
export class ToastComponent {
  constructor(public toastService: ToastService) {}

  /**
   * Check if toast content is a template
   */
  isTemplate(toast: ToastInfo): boolean {
    return toast.textOrTpl instanceof TemplateRef;
  }

  /**
   * Track function for ngFor to improve performance
   */
  trackByToastId(index: number, toast: ToastInfo): number {
    return toast.id;
  }
}
